import React from 'react';
import { isDeleteDisabled, isCancelExportDisabled, isExportDisabled } from '../../../../services';
import { ActionMenu } from '../../../../components';
import { ICONS } from '../../../../interfaces';
export var EditListMenu = function (_a) {
    var conditions = _a.conditions, buttonHandlers = _a.buttonHandlers, stripes = _a.stripes;
    var isExportInProgress = conditions.isExportInProgress;
    var actionButtons = [];
    var initExportButton = {
        label: 'export',
        icon: ICONS.download,
        onClick: buttonHandlers.export,
        disabled: isExportDisabled(conditions)
    };
    var cancelExportButton = {
        label: 'cancel-export',
        icon: ICONS.download,
        onClick: buttonHandlers['cancel-export'],
        disabled: isCancelExportDisabled(conditions)
    };
    var exportSlot = isExportInProgress ? cancelExportButton : initExportButton;
    var deleteSlot = {
        label: 'delete',
        icon: ICONS.trash,
        onClick: buttonHandlers.delete,
        disabled: isDeleteDisabled(conditions)
    };
    if (stripes.hasPerm("lists.item.export.get" /* USER_PERMS.ExportList */)) {
        actionButtons.push(exportSlot);
    }
    if (stripes.hasPerm("lists.item.delete" /* USER_PERMS.DeleteList */)) {
        actionButtons.push(deleteSlot);
    }
    return actionButtons.length ? React.createElement(ActionMenu, { actionButtons: actionButtons }) : React.createElement(React.Fragment, null);
};
